import Konva from 'konva';
import { Circle } from 'react-konva';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { getHandleHitFunc } from './flattenAreaToolUtils';

const HANDLE_RADIUS = 2;
const HANDLE_STROKE_WIDTH = 1;
const HANDLE_HIT_PADDING = 15; // extra tap/click buffer around the dot, screen-space
const ACTIVE_HANDLE = {
	fill: '#ddedfe',
	stroke: '#FFFFFF',
};

export interface PolygonHandleProps {
	x: number;
	y: number;
	draggable?: boolean;
	listening?: boolean;
	onDragStart?: (e: Konva.KonvaEventObject<DragEvent>) => void;
	onDragMove?: (e: Konva.KonvaEventObject<DragEvent>) => void;
	onDragEnd?: (e: Konva.KonvaEventObject<DragEvent>) => void;
	onPointerDown?: (e: Konva.KonvaEventObject<PointerEvent>) => void;
}

export default function PolygonHandle({
	x,
	y,
	draggable,
	listening,
	onDragStart,
	onDragMove,
	onDragEnd,
	onPointerDown,
}: PolygonHandleProps) {
	const zoomLevel = useSelector((state: RootState) => state.toolNewPostions.data.zoomLevel);
	// hitFunc geometry scales with zoom (stroke width doesn't) — pre-divide to cancel it.
	const hitPadding = HANDLE_HIT_PADDING / zoomLevel;

	return (
		<Circle
			x={x}
			y={y}
			radius={HANDLE_RADIUS}
			fill={ACTIVE_HANDLE.fill}
			stroke={ACTIVE_HANDLE.stroke}
			strokeWidth={HANDLE_STROKE_WIDTH}
			strokeScaleEnabled={false}
			hitFunc={getHandleHitFunc(HANDLE_RADIUS, hitPadding)}
			draggable={draggable}
			listening={listening}
			onDragStart={onDragStart}
			onDragMove={onDragMove}
			onDragEnd={onDragEnd}
			onPointerDown={onPointerDown}
		/>
	);
}
